<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" :canAdd="false"
        :isSearch="true" :canSearch="false">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados da Mortalidade</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md4 lg4>
                    <SelectDate :rules="[campoObrigatorio, validarData, validarDataFutura]" label="Data" v-model="dataBaixa"></SelectDate>
                </v-flex>
                <v-flex class="item" xs11 md4 lg4>
                    <v-text-field :rules="[campoObrigatorio, campoMaiorZero]" v-model.number="registro.qtBaixa" type="tel" label="Quantidade" 
                        outlined clearable v-mask="maskQuantidade">
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md3 lg3>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.sgSexo" :items="listaGeneros"
                        color="primary" item-text="dsGenero" item-value="sgGenero" label="Gênero" outlined
                        :readonly="sgSexoLote !== 'MI'" :filled="sgSexoLote !== 'MI'" >
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md6 lg6>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdMotivoBaixa" :items="listaMotivoBaixa" clearable
                        color="primary" item-text="nmMotivoBaixa" item-value="idMotivoBaixa" label="Motivo" outlined>
                    </v-autocomplete>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5>
                    <v-text-field v-model.number="registro.nrMossa" type="tel" label="Mossa" 
                        outlined clearable v-mask="maskNumber">
                    </v-text-field>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout row wrap justify-center>
            <v-flex class="item" xs11 md6 lg6>
                <v-text-field type="number" v-model.number="registro.nrPeso" label="Peso médio(kg)" outlined clearable>
                </v-text-field>
            </v-flex>
            <v-flex class="item" xs11 md5 lg5 pl-3 mt-0>
                <v-radio-group v-model="csPesoBalancaTela" row style="margin-top: 12px;">
                    <v-radio color="primary" label="Estimado" value="ES"></v-radio>
                    <v-radio color="primary" label="Balança" value="BA"></v-radio>
                </v-radio-group>
            </v-flex>
        </v-layout>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio, validarData, validarDataFutura, campoMaiorZero } from '@/filters/rules'
import { MensagemSuccessSave } from '@/resourceMessageFile.js'
import { dateLocalToIso, dateIsoToLocal } from '@/filters/utils'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'
import SelectDate from '@/components/general/SelectDate.vue'
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex';

export default {
    name: 'Baixa',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
        SelectDate,
    },
    directives: {
        mask,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            isLoading: false,
            cdLoteProducao: 0,
            dataBaixa: '',
            csPesoBalancaTela: "ES",
            maskPeso: '###',
            maskQuantidade: '#######',
            maskNumber: '##########',
            sgSexoLote: null
        }
    },
    computed: {
        ...mapState(["listaGeneros"]),
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Mortalidade: ' + this.registro.idBaixa

                return 'Inserindo nova Mortalidade'
            }
        },
        listaMotivoBaixa () {
            return this.$store.state.motivosBaixa
        },
    },
    methods: {
        campoObrigatorio,
        campoSelectObrigatorio,
        validarData, 
        validarDataFutura, 
        campoMaiorZero,
        dateLocalToIso,
        dateIsoToLocal,
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadMotivosBaixa')
            this.cdLoteProducao = parseInt(route.params.idLote)
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            this.$axios.get('baixa/' + id)
            .then((response) => {
                var rec = response.data[0].data
                this.csPesoBalancaTela = rec.csPesoBalanca ? 'BA' : 'ES'
                this.registro = Object.assign({}, rec)
                this.dataBaixa = this.dateIsoToLocal(rec.dtBaixa)                
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.registro.dtBaixa = this.dateLocalToIso(this.dataBaixa)
            this.registro.csPesoBalanca = this.csPesoBalancaTela == 'BA' ? true : false
          
            if (this.registro.nrPeso === "") this.registro.nrPeso = null
            if (this.registro.nrMossa === "") this.registro.nrMossa = null
            this.$axios.post('baixa/', this.registro)
            .then(() => {
                this.$router.go(-1)
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.registro.dtBaixa = this.dateLocalToIso(this.dataBaixa)
            this.registro.csPesoBalanca = this.csPesoBalancaTela == 'BA' ? true : false
          
            if (this.registro.nrPeso === "") this.registro.nrPeso = null
            if (this.registro.nrMossa === "") this.registro.nrMossa = null
          
            this.$axios.put('baixa/' + this.registro.idBaixa, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('baixa/' + this.registro.idBaixa)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idBaixa: '',
                dtBaixa: null,
                qtBaixa: 0,
                cdMotivoBaixa: null,
                flSacrificio: false,
                cdLoteProducao: this.cdLoteProducao,
                nrPeso: '',
                csPesoBalanca: null,
                sgSexo: '',
                nrMossa: ''
            }
        },
        loadLoteProducao() {
            this.batch = {}
            this.$axios.get('lote-producao/'+ this.$route.params.idLote)
            .then(response => {
                if(!response.data) return
                if(!response.data[0]) return

                this.sgSexoLote = response.data[0].data.sgSexo
                if (this.sgSexoLote !== 'MI') this.registro.sgSexo = this.sgSexoLote
            })
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
        this.loadLoteProducao()
    },
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
